import { times } from "lodash-es";

import { Skeleton } from "src/design-system/Skeleton";
import { Cell } from "src/flow/VersionsTable/VersionsTable";

export const VersionsTableRowSkeleton: React.FC<{
  numberOfColumns: number;
}> = ({ numberOfColumns }) => (
  <tr>
    {times(numberOfColumns, (i: number) => (
      <Cell key={i}>
        <Skeleton height="h-5" />
      </Cell>
    ))}
  </tr>
);
